import { decodeToken } from 'react-jwt';
import interfaceBridge from './interfaceBridge';
import { AccessTokenPayloadT, TokenObjT } from 'types/shared/core/Token';

class Token {
  static getAccessTokenPayload(token: string): AccessTokenPayloadT | null {
    const decoded = Token.safeDecodeToken<AccessTokenPayloadT>(token);
    if (decoded === null) return null;
    return decoded;
  }

  static getToken(kind: 'accessToken' | 'refreshToken') {
    const data = interfaceBridge.getData('CURRENT_USER_ID');
    // console.log(`currentUserId=${data}`);
    const currentUserId = parseInt(data);
    // console.log('currentUserId', currentUserId);
    if (!currentUserId) return '';

    const tokenObj: TokenObjT | null = interfaceBridge.loadToken(currentUserId);

    if (!tokenObj) return '';

    return tokenObj[kind];
  }

  static getCurrentUserId(): number | null {
    const data = interfaceBridge.getData('CURRENT_USER_ID');
    const currentUserId = parseInt(data);
    if (!currentUserId) return null;
    return currentUserId;
  }

  static setCurrentUserId(id: number) {
    interfaceBridge.setData('CURRENT_USER_ID', id.toString());
  }

  // --------------------------------------------------------
  // 여기부터 내부용 디코더 (Chrome 66 등 구버전 WebView 대응)
  // --------------------------------------------------------
  private static safeDecodeToken<T = unknown>(token: string): T | null {
    if (!token || typeof token !== 'string') return null;

    try {
      const parts = token.split('.');
      if (parts.length < 2) return null;

      const base64Url = parts[1];

      // base64url → base64
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

      // 🔧 padding 보정 (Chrome 66 의 atob 문제 회피)
      const pad = base64.length % 4;
      if (pad) {
        base64 += '='.repeat(4 - pad);
      }

      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );

      return JSON.parse(jsonPayload) as T;
    } catch (e) {
      // 혹시 모를 예외 상황에서는 기존 라이브러리에 한 번 더 위임
      try {
        const fallback = decodeToken<T>(token);
        return fallback === null ? null : fallback;
      } catch {
        return null;
      }
    }
  }
}

export default Token;
